<template>
  <div class="cases-detail">
    <section class="cases-detail-hero">
      <div class="cases-detail-bg">
        <img src="/static/jt.png" alt="典型案例">
        <div class="cases-detail-overlay"></div>
      </div>
      <div class="cases-detail-content">
        <h1 class="fade-in-up">典型案例</h1>
        <p class="hero-subtitle fade-in-up delay-1">CLASSIC CASES</p>
      </div>
    </section>

    <section class="cases-filter-section">
      <div class="container">
        <div class="filter-nav" data-aos="fade-up">
          <div
            v-for="cat in categories"
            :key="cat.id"
            :class="['filter-nav-item', { active: activeCategory === cat.id }]"
          >
            {{ cat.name }}
          </div>
        </div>
      </div>
    </section>

    <section class="cases-detail-main">
      <div class="container">
        <div class="detail-content">
          <h2 class="detail-title" data-aos="fade-up">{{ caseDetail.name }}</h2>

          <div class="detail-image" data-aos="zoom-in">
            <img :src="caseDetail.image" :alt="caseDetail.name">
          </div>

          <div class="detail-section" data-aos="fade-up" data-aos-delay="100">
            <span class="section-label">案例介绍</span>
            <div class="section-text">
              <p v-for="(paragraph, idx) in paragraphs" :key="idx">{{ paragraph }}</p>
            </div>
          </div>

          <div class="detail-actions" data-aos="fade-up" data-aos-delay="200">
            <router-link to="/cases" class="back-btn">
              <i class="el-icon-arrow-left"></i>
              返回
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mockCaseDetail } from '@/api/mock'

export default {
  name: 'CasesDetail',
  data() {
    return {
      caseDetail: { ...mockCaseDetail },
      categories: [
        { id: 'all', name: '典型案例' },
        { id: 'sanitation', name: '环卫工程' },
        { id: 'brand', name: '品牌建设' },
        { id: 'desert', name: '石漠化工' },
        { id: 'investment', name: '投资运营' },
        { id: 'agriculture', name: '农林土地' },
        { id: 'smart', name: '数智案例' },
        { id: 'solid', name: '固废治理' }
      ],
      activeCategory: 'all'
    }
  },
  computed: {
    paragraphs() {
      return this.caseDetail.content ? this.caseDetail.content.split('\n').filter(p => p.trim()) : []
    }
  }
}
</script>

<style lang="scss" scoped>
.cases-detail-hero {
  position: relative;
  height: 420px;
  overflow: hidden;
}

.cases-detail-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.cases-detail-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.85) 0%, rgba(26, 86, 219, 0.7) 100%);
}

.cases-detail-content {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 8%;
}

.cases-detail-content h1 {
  font-size: 52px;
  font-weight: 700;
  color: white;
  margin-bottom: 12px;
  letter-spacing: 4px;
}

.hero-subtitle {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.75);
  letter-spacing: 6px;
  font-weight: 300;
}

.cases-filter-section {
  background: white;
  border-bottom: 1px solid #e8ecf1;
}

.filter-nav {
  display: flex;
  align-items: center;
}

.filter-nav-item {
  position: relative;
  padding: 22px 28px;
  font-size: 16px;
  color: #64748b;
  font-weight: 500;
  line-height: 1;

  &.active {
    color: #1a56db;
    font-weight: 600;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 40px;
      height: 3px;
      background: #1a56db;
    }
  }
}

.cases-detail-main {
  padding: 50px 0 80px;
  background: #f7f9fc;
}

.detail-content {
  max-width: 960px;
  margin: 0 auto;
  background: white;
  border-radius: 16px;
  padding: 50px 60px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.05);
}

.detail-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f1f5f9;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 50px;
    height: 2px;
    background: linear-gradient(135deg, #1a56db, #4f46e5);
  }
}

.detail-image {
  margin-bottom: 40px;
  border-radius: 12px;
  overflow: hidden;

  img {
    width: 100%;
    height: 420px;
    object-fit: cover;
  }
}

.detail-section {
  margin-bottom: 40px;
}

.section-label {
  display: inline-block;
  padding-bottom: 10px;
  margin-bottom: 24px;
  font-size: 18px;
  font-weight: 600;
  color: #1a56db;
  border-bottom: 2px solid #1a56db;
}

.section-text {
  p {
    font-size: 15px;
    color: #475569;
    line-height: 2;
    margin-bottom: 16px;
    text-align: justify;
    text-indent: 2em;
  }
}

.detail-actions {
  padding-top: 30px;
  border-top: 1px solid #f1f5f9;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border: 1px solid #e2e8f0;
  border-radius: 25px;
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  background: white;

  i {
    font-size: 14px;
  }

  &:hover {
    border-color: #1a56db;
    color: #1a56db;
    box-shadow: 0 4px 12px rgba(26, 86, 219, 0.15);
  }
}

@media (max-width: 992px) {
  .cases-detail-content h1 {
    font-size: 40px;
  }

  .filter-nav-item {
    padding: 18px 20px;
    font-size: 15px;
  }

  .detail-content {
    padding: 40px 35px;
  }

  .detail-title {
    font-size: 26px;
  }

  .detail-image img {
    height: 320px;
  }
}

@media (max-width: 768px) {
  .cases-detail-hero {
    height: 320px;
  }

  .cases-detail-content {
    padding: 0 24px;
  }

  .cases-detail-content h1 {
    font-size: 32px;
    letter-spacing: 2px;
  }

  .hero-subtitle {
    font-size: 14px;
    letter-spacing: 4px;
  }

  .filter-nav {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .filter-nav-item {
    padding: 16px 18px;
    font-size: 14px;
    white-space: nowrap;
  }

  .cases-detail-main {
    padding: 30px 0 50px;
  }

  .detail-content {
    padding: 25px 20px;
    border-radius: 12px;
  }

  .detail-title {
    font-size: 22px;
    margin-bottom: 24px;
    padding-bottom: 16px;
  }

  .detail-image {
    margin-bottom: 28px;

    img {
      height: 220px;
    }
  }

  .section-label {
    font-size: 16px;
  }

  .section-text p {
    font-size: 14px;
    line-height: 1.9;
  }
}
</style>